









import Vue from 'vue'
import CreditCardAdd from '@/components/CreditCardAdd.vue'

export type DataType = {
  pageName: string
  breadcrumbs: unknown[]
}

export default Vue.extend({
  components: { CreditCardAdd },
  data(): DataType {
    return {
      pageName: this.$route.meta.title,
      breadcrumbs: [
        {
          text: 'HOME',
          href: '/member',
        },
        {
          text: `${this.$route.meta.title}`,
          disabled: true,
        },
      ],
    }
  },
})
